import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LOGIN } from '../../shared/routes/path';
import Loader from '../../shared/components/common/loader/Loader';
import { verifyEmail } from './services/VerifyEmailService';

const VerifyEmailPage: React.FC = () => {
  const { hash } = useParams<{ hash: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (hash) {
      verifyEmail(hash)
        .then(() => navigate(LOGIN, { state: { emailVerified: 'success' }, replace: true }))
        .catch(() => navigate(LOGIN, { state: { emailVerified: 'error' }, replace: true }));
    } else {
      navigate(LOGIN, { state: { emailVerified: 'error' }, replace: true });
    }
  }, []);

  return <Loader />;
};

export default VerifyEmailPage;
